angular.module('impactx.list').directive('appListAction', function()
{
    return {
        scope: {
            translation: '@',
            action: '&',
            process: '@',
            icon: '@'
        },
        restrict: 'E',
        controller: 'ListActionCtrl',
        templateUrl: 'shared/list/templates/listActionView.html',
        transclude: true
    };
});
